import { createContext } from 'react'
import { IClientDocumentVerification } from 'typescript/interfaces/documentVerification'

const DocumentVerificationContext = createContext<IClientDocumentVerification | undefined>(undefined)

export { DocumentVerificationContext }
